import { render, staticRenderFns } from "./Openvip.vue?vue&type=template&id=e57458cc&scoped=true&"
import script from "./Openvip.vue?vue&type=script&lang=js&"
export * from "./Openvip.vue?vue&type=script&lang=js&"
import style0 from "./Openvip.vue?vue&type=style&index=0&id=e57458cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57458cc",
  null
  
)

export default component.exports